import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Lectures/Create';

const { displayName } = config;

function LectureCreate(): React.JSX.Element {
  document.title = `${displayName}: Добавить лекцию`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default LectureCreate;
